import { recoverPasswordTypes } from "../actionTypes/recoverPasswordTypes";

const INITIAL_STATE = {
  email: [],
  email_success: false,
  email_failure: false,
  email_loader: false,
  resetPasswordDetails: [],
  resetPassword_success: false,
  resetPassword_failure: false,
  resetPassword_loader: false,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case recoverPasswordTypes.RECOVER_EMAIL:
      return {
        ...state,
        email: action.email,
        email_loader: true,
        email_success: false,
        email_failure: false,
      };
    case recoverPasswordTypes.RECOVER_EMAIL_LOADER:
      return {
        ...state,
        email_loader: action.email_loader,
      };
    case recoverPasswordTypes.RECOVER_EMAIL_SUCCESS:
      return {
        ...state,
        email_success: action.email_success,
        email_failure: false,
        email_loader: false,
      };
    case recoverPasswordTypes.RECOVER_EMAIL_FAILURE:
      return {
        ...state,
        email_failure: action.email_failure,
        email_success: false,
        email_loader: false,
      };

      case recoverPasswordTypes.RESET_PASSWORD_DETAILS:
          return {
              ...state,
              resetPasswordDetails: action.resetPasswordDetails,
              resetPassword_loader: true,
              resetPassword_failure: false,
              resetPassword_success: false,
          }
          case recoverPasswordTypes.RESET_PASSWORD_FAILURE:
              return {
                  resetPassword_failure: action.resetPassword_failure,
                  resetPassword_loader: false,
              }
              case recoverPasswordTypes.RESET_PASSWORD_SUCCESS:
                  return {
                      ...state,
                      resetPassword_success: action.resetPassword_success,
                      resetPassword_loader: false,
                  };
                  case recoverPasswordTypes.RESET_PASSWORD_LOADER:
                      return {
                          ...state,
                            resetPassword_loader: action.resetPassword_loader
                      }
    default:
      return state;
  }
};
